import Axios from 'axios'
import React from 'react'

import Loader from './Loader'

import StorageHelper from 'services/storageHelper'
import { StorageType } from 'types'

const CACHE_STORAGE_KEY = 'StaticContent'

/**
 * Container component loading and inserting static html from an url
 */
export default class StaticContent extends React.Component<
  StaticContentProps & React.HTMLAttributes<any>,
  StaticContentState
  > {
  static defaultProps = {
    cache: false,
    showLoader: true,
  }

  state = {
    isLoading: false,
    error: false,
    content: null,
  }

  storage: StorageType

  constructor(props) {
    super(props)

    this.storage = new StorageHelper(sessionStorage)
  }

  loadContent = (url: string, htmlTransforms?: HtmlTransform[]) => {
    this.setState({
      isLoading: true,
      content: null,
    })
    return Axios.get(url)
      .then(response => response.data)
      .then(content => {
        if (htmlTransforms) {
          content = htmlTransforms.reduce((result, transform) => transform(result), content)
        }
        this.setState({
          isLoading: false,
          content,
        })
        return content
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error,
          content: null,
        })
      })
  }

  componentDidMount() {
    const { cache, children, htmlTransform } = this.props
    const url = children
      ? `/static/${children}.html`
      : null
    let contentsCache
    let content
    if (url) {
      if (cache) {
        contentsCache = this.storage.getItem(CACHE_STORAGE_KEY)
        if (contentsCache && url in contentsCache) {
          content = contentsCache[url]
          this.setState({
            isLoading: false,
            content,
          })
        }
      }
      if (!content) {
        const htmlTransforms = htmlTransform && (Array.isArray(htmlTransform) ? htmlTransform : [htmlTransform])
        this.loadContent(url, htmlTransforms)
          .then(loadedContent => {
            if (cache) {
              this.storage.setItem(CACHE_STORAGE_KEY, { ...contentsCache || {}, [url]: loadedContent,})
            }
          })
          .catch(() => {
            if (cache) {
              if (contentsCache) delete(contentsCache[url])
              this.storage.setItem(CACHE_STORAGE_KEY, contentsCache || {})
            }
          })
      }
    }
  }

  render() {
    const { cache, showLoader, htmlTransform, children, ...otherProps } = this.props
    const { isLoading, content } = this.state
    const innerHtml = content ? { __html: content } : null
    return (
      <div {...otherProps}>
        {showLoader && <Loader visible={isLoading} local />}
        {innerHtml && <div dangerouslySetInnerHTML={innerHtml} />}
      </div>
    )
  }
}

type StaticContentProps = {
  cache?: boolean,
  showLoader?: boolean,
  htmlTransform?: HtmlTransform | HtmlTransform[],
  children: React.ReactText,
}

type HtmlTransform = (html: string) => string

type StaticContentState = {
  isLoading: boolean,
  error: boolean,
  content: string | null,
}
